'use strict';

const { signDirection } = require('./compensationMetrics');

/**
 * Human-readable pay vs market label.
 * Always uses absolute percent — direction is conveyed by words, not a minus sign.
 *
 * @param {{ payGapDollars?: number|null, payGapPct?: number|null, formatCurrency?: (n:number)=>string }} params
 * @returns {string}
 */
function formatPayVsMarketLabel({
  payGapDollars = null,
  payGapPct = null,
  formatCurrency = (n) => `$${Math.round(Math.abs(n)).toLocaleString('en-US')}`,
} = {}) {
  const dollars = Number(payGapDollars);
  const pct = Number(payGapPct);
  const hasDollars = Number.isFinite(dollars);
  const hasPct = Number.isFinite(pct);

  const dirFromDollars = hasDollars ? signDirection(dollars) : 0;
  const dirFromPct = hasPct ? signDirection(pct) : 0;
  const direction = dirFromDollars !== 0 ? dirFromDollars : dirFromPct;

  const pctAbs = hasPct ? Math.round(Math.abs(pct)) : null;
  const pctLabel = pctAbs != null && pctAbs > 0 ? ` (${pctAbs}%)` : '';

  if (direction > 0) {
    const amount = hasDollars ? formatCurrency(Math.abs(dollars)) : null;
    return amount ? `Below market by ${amount}${pctLabel}` : `Below market${pctLabel}`;
  }
  if (direction < 0) {
    const amount = hasDollars ? formatCurrency(Math.abs(dollars)) : null;
    return amount ? `Above market by ${amount}${pctLabel}` : `Above market${pctLabel}`;
  }
  if (hasDollars || hasPct) return 'At market rate';
  return '';
}

module.exports = {
  formatPayVsMarketLabel,
};
